export const usePlacement = (): "bottom" | "top" => {
  return "bottom";
};
